module.exports = __webpack_public_path__ + "img/vehicles.cc19d19a.svg";